import api from '../token';

export const AlterFpagamento = async (dados) => {
  try {
    const response = await api.post('/alterFPagamento', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
